import { render, staticRenderFns } from "./SubjectSlidebar.vue?vue&type=template&id=230d2d1a"
import script from "./SubjectSlidebar.vue?vue&type=script&lang=js"
export * from "./SubjectSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports